// =============================================================================
//  Copyright : 2022 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : frontend parts
// =============================================================================
// ---Third-party imports
import React from 'react'
import {Title} from 'react-head'

// ---Framework imports
import log from 'uix/logging'
import {Sel} from 'uix/registries'
import {useSelector} from 'uix/hooks'
import {ucFirst} from 'uix/utils'
import {reversed} from 'ldash'
import {funcPart} from 'uix/parts'

// ---Local imports
import {useIndexList} from './hooks'
import {Facets, Titles} from './components'

// ---Exports imports

export const MyPart = ({}) => {
  let result = useIndexList({limit: 10})
  return (
    <>
      <Titles titles={result.titles} />
      <Facets facets={result.facets} />
    </>
  )
}

// ---Exports
export const HTMLHead = funcPart({wrapped: false}, ({}) => {
  let req = useSelector(Sel.request)
  let node = useSelector(Sel.currentNode)
  let ddescr = useSelector(Sel.domainDescription)

  let blocks = []
  blocks.push(ddescr)

  if (node && node.datatypeName != 'domain') {
    // special case intra md nodes
    let md_struct_labels = node.ancestors
      ?.filter(({datatype}) => [0, 1].includes(datatype))
      .map(e => e.label)
    if (md_struct_labels) {
      blocks.push(...reversed(md_struct_labels))
    }
    blocks.push(node.label)
  } else {
    // XXX: translate tabgoups & tabs
    blocks.push(`${ucFirst(req.classname)} - ${ucFirst(req.tabname)}`)
  }

  return <Title>{blocks.join(' - ')}</Title>
})
